import { DARK } from '../constants/colors';
import { fmtK } from '../utils/formatters';

export default function ChartTip({active,payload,label}){
  if(!active||!payload?.length)return null;
  return(
    <div style={{background:"#fff",border:"1px solid #E2E8F0",borderRadius:12,padding:"13px 16px",boxShadow:"0 8px 24px rgba(0,0,0,0.14)",fontFamily:"sans-serif",minWidth:160}}>
      <p style={{margin:"0 0 8px",fontWeight:700,color:DARK,fontSize:13}}>Year {label}</p>
      {payload.map((p,i)=>(
        <div key={i} style={{display:"flex",justifyContent:"space-between",gap:16,margin:"4px 0"}}>
          <span style={{fontSize:12,color:"#64748b"}}>{p.name}</span>
          <span style={{fontSize:12,fontWeight:700,color:p.color}}>{fmtK(p.value)}</span>
        </div>
      ))}
    </div>
  );
}
